import { createStmWithUpdateCosignToken, refreshCosignToken } from '@hooks-api/fortune/refreshCosignToken'
import { type AxiosError } from 'axios'
import { useEffect, useMemo } from 'react'
import { type BrandInfo } from '../constants'
import { useActiveBrands, useStmBrandStore } from '../hooks'

interface RefreshBrandTokenProps {
  brand: BrandInfo
}

/** 對所有未過期品牌定期 refresh x-platform-token，401 視為品牌過期。 */
const RefreshBrandToken = ({ brand }: RefreshBrandTokenProps) => {
  const campaignCode = brand.campaignCode
  const middleware = useMemo(() => createStmWithUpdateCosignToken(campaignCode), [campaignCode])
  const { error } = refreshCosignToken({ code: campaignCode }, { use: [middleware] })
  const setExpiredCampaignCodes = useStmBrandStore(state => state.setExpiredCampaignCodes)

  useEffect(function markBrandExpiredOnRefreshFailure() {
    if ((error as AxiosError)?.response?.status === 401) {
      setExpiredCampaignCodes(campaignCode)
    }
  }, [error, campaignCode, setExpiredCampaignCodes])

  return null
}

export const StmRefreshPlatformToken = () => {
  const activeBrands = useActiveBrands()

  return (
    <>
      {activeBrands.map(brand => (
        <RefreshBrandToken key={brand.campaignCode} brand={brand} />
      ))}
    </>
  )
}
